import React from "react";

function OtpIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_1848_3361)">
        <path
          d="M12 1C12.2156 1 12.4313 1.04688 12.6281 1.13594L21.4547 4.88125C22.486 5.31719 23.2547 6.33438 23.25 7.5625C23.2266 12.2125 21.3141 20.7203 13.2375 24.5875C12.4547 24.9625 11.5453 24.9625 10.7625 24.5875C2.68596 20.7203 0.773459 12.2125 0.750021 7.5625C0.745334 6.33438 1.51408 5.31719 2.54533 4.88125L11.3766 1.13594C11.5688 1.04688 11.7844 1 12 1ZM12 4.13125V21.85C18.4688 18.7188 20.2078 11.7859 20.25 7.62813L12 4.13125Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1848_3361">
          <path d="M0 0H24V24H0V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default OtpIcon;
